export default {
  '--app-primary-color': 'hsl(196, 100%, 16%)',
  '--app-secondary-color': 'hsl(219, 52%, 40%)',
  '--app-tertiary-color': 'hsl(205, 50%, 90%)',
  '--app-disabled-color': 'hsl(220, 12%, 95%)',
  '--sidebar-bg-color': 'hsl(196, 54.80%, 12.20%)',
  '--sidebar-icon-color': 'hsl(0, 0%, 100%)',
  '--sidebar-text-color': 'hsl(0, 0%, 100%)',
  '--sidebar-active-bg-color': 'hsl(219, 52%, 40%)',
  '--sidebar-active-text-color': 'hsl(0, 0%, 100%)'
};
